/**
 * Ranura de migas propia de página: por defecto el Shell pinta «Studio /
 * lista / slug»; un detalle que sabe más (la ficha: «Conocimiento / C10 ·
 * Marketing… / slug», ficha.html) pone aquí sus migas tras «Studio». Se
 * limpia al desmontar o al cambiar de ruta. El molde de `asideSlot`.
 */
import { createContext, useContext, useEffect, type ReactNode } from "react";

const CrumbSlotCtx = createContext<((items: ReactNode[] | null) => void) | null>(null);
export const CrumbSlotProvider = CrumbSlotCtx.Provider;

/** `items`: las migas tras «Studio» (la última va en negrita); `key` decide cuándo repintar. */
export function useCrumbs(items: ReactNode[] | null, key: string) {
  const set = useContext(CrumbSlotCtx);
  useEffect(() => {
    set?.(items);
    return () => set?.(null);
    // `items` son elementos nuevos en cada render: manda la clave
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, set]);
}
